<ion-app>
  <ion-split-pane
    contentId="main-content"
    [disabled]="(splitPane.active | async) === false"
    [when]="splitPane.when | async"
  >
    <ion-menu contentId="main-content" type="overlay">
      <ion-header>
        <ion-toolbar>
          <img
            class="logo"
            src="/assets/img/ACMaster-SAS.svg"
            alt="ACMaster logo"
          />
        </ion-toolbar>
      </ion-header>

      <ion-content
        class="outer-content"
        [ngClass]="{ loaded: true }"
        tourAnchor="intro"
      >
        <div class="ios-spacer"></div>
        <ion-list class="page-buttons no-last-border" tourAnchor="nav1">
          <ion-menu-toggle auto-hide="false">
            <ion-item
              *ngFor="let p of appPages"
              routerDirection="root"
              routerLinkActive="active-link"
              [routerLink]="p.url"
              [disabled]="
                (auth.isAuthenticated$ | async) === false ||
                syncStatus === 'Unauthorized'
              "
              [routerLinkActiveOptions]="p?.options || {}"
            >
              <fa-icon
                *ngIf="p.icon"
                slot="start"
                [icon]="$any(p.icon)"
              ></fa-icon>
              <fa-layers *ngIf="!p.icon" slot="start">
                <fa-icon
                  [icon]="['fal', 'border-all']"
                  transform="grow-8"
                ></fa-icon>
                <fa-icon
                  [icon]="['fad', 'map']"
                  transform="shrink-2 rotate-30"
                ></fa-icon>
              </fa-layers>
              {{ p.title }}
              <ion-badge
                slot="end"
                *ngIf="p.count && (this.auth.user$ | async)"
                data-id="{{ p.title.toLocaleLowerCase() + '-count' }}"
                >{{ p.count }}</ion-badge
              >
              <!-- <fa-icon
                slot="end"
                *ngIf="online() && !(appReady.appReady$ | async) && currentUser"
                [icon]="['fad', 'sync-alt']"
                title="Loading"
                animation="spin"
              ></fa-icon> -->
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list
          *ngIf="(this.userData.user$ | async)?.['isStaff']"
          class="coursecast-buttons no-last-border"
        >
          <ion-list-header> Coursecasts </ion-list-header>
          <ion-menu-toggle auto-hide="false">
            <ng-container *ngFor="let p of seriesPages">
              <ion-item
                [routerLink]="p.url"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                [disabled]="(auth.isAuthenticated$ | async) === false"
              >
                <fa-icon slot="start" [icon]="$any(p.icon)"></fa-icon>
                {{ p.title }}
              </ion-item>
            </ng-container>
          </ion-menu-toggle>
        </ion-list>

        <ion-list class="account-buttons no-last-border" tourAnchor="nav2">
          <ion-list-header> Account </ion-list-header>
          <ion-menu-toggle auto-hide="false">
            <ng-container *ngIf="showLogin">
              <ion-item
                *ngIf="(auth.isAuthenticated$ | async) === false"
                (click)="loginWithRedirect()"
                class="ion-activatable"
              >
                <fa-icon slot="start" [icon]="['fad', 'sign-in-alt']"></fa-icon>
                Log in
              </ion-item>
              <ion-item
                *ngIf="auth.isAuthenticated$ | async"
                (click)="online() && logout()"
                class="ion-activatable"
                [disabled]="!online()"
                data-cy="logout"
              >
                <fa-icon
                  slot="start"
                  [icon]="['fad', 'sign-out-alt']"
                ></fa-icon>
                Log Out
                <fa-icon
                  slot="end"
                  *ngIf="!online()"
                  [icon]="['fad', 'wifi-slash']"
                  title="Not connected"
                ></fa-icon>
              </ion-item>
            </ng-container>
            <ng-container *ngIf="!showLogin">
              <ion-item
                (click)="toLogin()"
                class="ion-activatable"
                [disabled]="!online()"
              >
                <fa-icon
                  slot="start"
                  [icon]="['fad', 'cloud-download']"
                ></fa-icon>
                Install
              </ion-item>
            </ng-container>
            <ng-container *ngFor="let p of accountPages">
              <ion-item
                *ngIf="auth.isAuthenticated$ | async"
                [routerLink]="p.url"
                routerLinkActive="active-link"
                [disabled]="
                  (auth.isAuthenticated$ | async) === false ||
                  syncStatus === 'Unauthorized'
                "
              >
                <fa-icon slot="start" [icon]="$any(p.icon)"></fa-icon>
                {{ p.title }}
              </ion-item>
            </ng-container>
          </ion-menu-toggle>
        </ion-list>

        <ion-list tourAnchor="nav3" class="help-buttons no-last-border">
          <ion-list-header> Help </ion-list-header>
          <ion-menu-toggle auto-hide="false">
            <ion-item
              *ngFor="let p of helpPages"
              routerLinkActive="active-link"
              [routerLink]="p.url"
            >
              <fa-icon slot="start" [icon]="$any(p.icon)"></fa-icon>
              {{ p.title }}
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list class="help-buttons no-last-border">
          <ion-list-header> Status </ion-list-header>
          <ion-menu-toggle auto-hide="false">
            <ion-item>
              <fa-icon
                slot="start"
                *ngIf="!online()"
                [icon]="['fad', 'wifi-slash']"
                title="Not connected"
              ></fa-icon>
              <fa-icon
                slot="start"
                *ngIf="online()"
                [icon]="['fad', 'wifi']"
                title="Network connected"
              ></fa-icon>
              <fa-icon
                slot="end"
                *ngIf="syncStatus === 'Initializing'"
                [icon]="['fad', 'stop']"
                title="Database initializing"
              ></fa-icon>
              <fa-icon
                slot="end"
                *ngIf="syncStatus === 'Error'"
                [icon]="['fad', 'exclamation-circle']"
                title="Database synchronization error"
              ></fa-icon>
              <fa-icon
                slot="end"
                *ngIf="syncStatus === 'Synchronized'"
                [icon]="['fad', 'check-circle']"
                title="Database up to date"
              ></fa-icon>
              <fa-icon
                slot="end"
                *ngIf="syncStatus === 'Synchronizing' || locallyTriggeredSync"
                [icon]="['fad', 'sync-alt']"
                title="Database synchronizing"
                animation="spin"
              ></fa-icon>
              <ion-button
                slot="end"
                size="small"
                color="primary"
                (click)="sync()"
                title="Manually synchronize with the server"
                [disabled]="
                  syncStatus === 'Synchronizing' || !currentUser || !online()
                "
                class="ion-margin-start"
                >Sync</ion-button
              >
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <span
          tourAnchor="getStarted"
          text="Next, follow the steps on this home page to get started."
        ></span>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"> </ion-router-outlet>
  </ion-split-pane>
</ion-app>
<tour-step-template></tour-step-template>
